// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gvhcfrYa06peQS,
.gvhcfrYa06peQS td {
  padding: 8px 0 12px 0;
  border: none;
}
.gvhcfrYa06peQS thead {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  border: 0;
  word-wrap: normal;
  white-space: nowrap;
}
.gvhcfrYa06peQS tr.Xh_mNGaycXSbrE {
  border: none;
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
.gvhcfrYa06peQS td.tXmy3rMawLp1ZK {
  padding: 8px 40px;
}
.gvhcfrYa06peQS td.or5PO5OjRt8KXK {
  text-align: right;
  white-space: nowrap;
}
.TMKyXf0V2dGxf4 {
  display: flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
}
.TMKyXf0V2dGxf4 p {
  margin-right: 10px;
  margin-left: 10px;
}
.ZozBArW00UYbnJ {
  position: absolute;
  right: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"billingHistoryTable": `gvhcfrYa06peQS`,
	"statement": `Xh_mNGaycXSbrE`,
	"description": `tXmy3rMawLp1ZK`,
	"amount": `or5PO5OjRt8KXK`,
	"pagination": `TMKyXf0V2dGxf4`,
	"showAll": `ZozBArW00UYbnJ`
};
export default ___CSS_LOADER_EXPORT___;
